// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".place[data-v-6750ec12] {\n  --magic-box-background: var(--magic-tertiary, #311261);\n}\n\n.text[data-v-6750ec12] {\n  color: var(--magic-light, #fff);\n}\n.text--points[data-v-6750ec12] {\n  color: var(--magic-light, #fff);\n}\n.text--prize[data-v-6750ec12] {\n  background: var(--magic-secondary, #6e20e8);\n}", ""]);
// Exports
module.exports = exports;
